(function () {
    "use strict";

    // @ngInject
    function CreateEventControllerCtor($scope, $injector, $state, $modalInstance, AppStates, config,
                                       AnalyticsService, EventsManager, EventService, WorkspaceService, OnboardingService, AbTestService, CalendarService,
                                       CompaniesManager, Enums, moment, ModelFactory, CompanyService, _, FacebookPixelTrackingService) {

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'CreateEventController';

        this.EventsManager = EventsManager;
        this.EventService = EventService;
        this.WorkspaceService = WorkspaceService;
        this.$state = $state;
        this.appStates = AppStates;
        this.modalInstance = $modalInstance;
        this.companiesManager = CompaniesManager;
        this.AnalyticsService = AnalyticsService;
        this.AbTestService = AbTestService;
        this.CalendarService = CalendarService;
        this.Enums = Enums;
        this.ModelFactory = ModelFactory;
        this.CompanyService = CompanyService;
        this.FacebookPixelTrackingService = FacebookPixelTrackingService;
        this._ = _;

        if (config){
            this.doNotGoToNewWorkspace = config.doNotGoToNewWorkspace;
            this.dateParams = config.dateParams;
            this.userId = config.userId;
        }

        this.event = EventsManager.newEvent();

        if (this.dateParams) {
            if (this.dateParams.date) {
                this.event.event_date = moment(
                    this.dateParams.date, 'MMM DD, YYYY').format('YYYY-MM-DD');
            }

            if (this.dateParams.time) {
                this.event.event_time_start = this.dateParams.time;
            }

            if (this.dateParams.time_end) {
                this.event.event_time_end = this.dateParams.time_end;
            }
        }

        this.company = this.companiesManager.getCurrCompany();

        this.AnalyticsService.trackLoad(this,this.AnalyticsService.analytics_events.create_project_modal);

        var defaultProjectTypeLabel = this.EventService.getDefaultProjectTypeLabel(this.company);
        var projectType = _.find(this.company.project_types, function(pt) { return pt.label === defaultProjectTypeLabel; }) || this.company.project_types[0];

        this.event.event_type = projectType.label;
        this.OnboardingService = OnboardingService;
        this.onboardingActive = this.OnboardingService.isOnboardingActive();

        if (this.onboardingActive) {
            this.OnboardingService.setStepComplete(this.OnboardingService.OnboardingSteps.createEventTooltip);
        }

        if (this.company.company_type === 'venue') {
            this.event.event_location = '';
            if (!this.company.street_address) {
                this.event.event_location += (this.company.company_name ? this.company.company_name + ', ' : '') ;
            }
            this.event.event_location += (this.company.street_address ? this.company.street_address + ', ' : '') ;
            this.event.event_location += (this.company.city ? this.company.city + ', ' : '') ;
            this.event.event_location += (this.company.state ? this.company.state + ' ' : '') ;
            this.event.event_location += (this.company.zip_code ? this.company.zip_code : '');
        }

        this.creatingEvent = false;

        // cover photo
        if (this.company && this.company.cover_images) {
            this.setInitialEventImage();
        } else{
            this.register(this.company, 'success', function success() {
                this.setInitialEventImage();
            });
        }

        this.eventsMasterCollection = ModelFactory.getEventsMasterCollection();

        // HACK: Needed to gain access to the child form state and helper methods
        // The child form component updates this property with a reference
        // to itself.
        this.eventFormBinding = {};
    }


    Controllers.CreateEventController = Class(Controllers.BaseController, {
        constructor: CreateEventControllerCtor,

        createEvent: function createEvent() {

            if (this.creatingEvent) {
                return;
            }

            this.eventFormBinding.setSubmitted();

            if (this.eventFormBinding.isDirty() &&
                this.eventFormBinding.isValid() &&
                !this.eventFormBinding.dateError) {

                this.creatingEvent = true;
                this.event.user_event_notes = [{text:this.eventNote}];

                this.EventsManager.createEvent(this.event, this.userId).then(function createEventSuccess(resp) {
                    this.AnalyticsService.trackSuccess(this, 'project created', this._getProjectAnalyticsProps(this.event));
                    this.FacebookPixelTrackingService.trackCustom('ProjectCreated');

                    var workspaceId = resp.data._id;
                    var shouldHideAddParticipantsModal = !!this.userId;

                    if (!this.doNotGoToNewWorkspace) {
                        this.WorkspaceService.gotoNewWorkspace(workspaceId, this.event._id, "general", this.showLeadSourceToast, shouldHideAddParticipantsModal);
                    }
                    this.modalInstance.close(resp.data);

                    if (this.onboardingActive) {
                        this.OnboardingService.setOnboardingWorkspace(workspaceId);
                        this.OnboardingService.setOnboardingEvent(this.event._id);
                        this.OnboardingService.setStepComplete(this.OnboardingService.OnboardingSteps.createEvent);
                    }

                    // Add the newly created event to the master collection and manually trigger a success
                    // this is mostly used by the calendar service.
                    this.eventsMasterCollection.add(this.event);
                }.bind(this))
                .catch(function createEventError(resp){
                    this.AnalyticsService.trackError(this, 'create event', this);
                    this.eventFormBinding.errorMessage = resp.data.error_message || resp.data;
                }.bind(this))
                .finally(function finallyHandler() {
                    this.creatingEvent = false;
                }.bind(this));
            }
        },

        cancelCreateEvent: function cancelCreateEvent(){
            this.modalInstance.dismiss();
        },

        setInitialEventImage: function setInitialEventImage() {
            this.event.event_image = this.EventService.getInitialProjectImage(this.company);
        },

        _getProjectAnalyticsProps: function _getProjectAnalyticsProps(project) {
            return this._.pick(project.dataOnly(),
                'event_name', 'event_type', 'event_timezone', 'event_date', 'event_end_date',
                'event_budget', 'event_guests', 'event_location', 'event_time_start', 'event_time_end', 'lead_source');
        }
    });
}());
